import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";
import { HOLIDAYS, holidayForDate, hexToRgb } from "../lib/holidays";

const MAIN_PAGES = ["/archive", "/members", "/", "/explore", "/foryou", "/concepts", "/stories", "/discover", "/donate"];

const COUNTS = { low: 12, normal: 26, high: 44 };

const HolidayBackground = ({ holiday, density }) => {
  const h = HOLIDAYS[holiday];
  const parts = useMemo(() => Array.from({ length: COUNTS[density] || 26 }, (_, i) => ({
    left: (i * 37) % 100, delay: -((i * 1.7) % 14), dur: 10 + ((i * 3) % 9), size: 12 + ((i * 7) % 16),
    Icon: h.icons[i % h.icons.length], color: h.colors[i % h.colors.length], top: (i * 53) % 100,
  })), [h, density]);
  return (
    <div data-testid={`holiday-bg-${holiday}`} aria-hidden className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
      {h.rainbow && <div className="kv-rainbow absolute inset-x-0 top-0 h-1.5 opacity-80" />}
      {parts.map(({ left, delay, dur, size, Icon, color, top }, i) => (
        <span key={i} className={`kv-particle kv-${h.motion}`}
          style={{ left: `${left}%`, top: h.motion === "twinkle" || h.motion === "float" ? `${top}%` : undefined, animationDelay: `${delay}s`, animationDuration: `${dur}s`, color }}>
          <Icon size={size} strokeWidth={1.6} fill={h.motion === "rise" ? "currentColor" : "none"} />
        </span>
      ))}
    </div>
  );
};

export const SiteTheme = () => {
  const loc = useLocation();
  const [theme, setTheme] = useState({ glow_color: "#00E5FF", holiday: "auto" });
  useEffect(() => {
    api.get("/site-theme").then(({ data }) => setTheme(data)).catch(() => {});
    const onChange = (e) => setTheme(e.detail);
    window.addEventListener("kv-theme", onChange);
    return () => window.removeEventListener("kv-theme", onChange);
  }, []);
  useEffect(() => {
    const r = document.documentElement;
    r.style.setProperty("--kv-glow", hexToRgb(theme.glow_color));
    r.style.setProperty("--kv-glow-i", String((theme.glow_intensity ?? 100) / 100));
    r.dataset.kvGrain = theme.grain ? "1" : "";
  }, [theme.glow_color, theme.glow_intensity, theme.grain]);
  const holiday = theme.holiday === "auto" ? holidayForDate() : theme.holiday === "none" ? null : theme.holiday;
  useEffect(() => {
    document.documentElement.dataset.kvSeason = holiday || "";
    window.__kvHoliday = { holiday, greeting: theme.greeting !== false };
    window.dispatchEvent(new CustomEvent("kv-holiday", { detail: window.__kvHoliday }));
  }, [holiday, theme.greeting]);
  if (!holiday || !HOLIDAYS[holiday] || theme.particles === "off" || !MAIN_PAGES.includes(loc.pathname)) return null;
  return <HolidayBackground holiday={holiday} density={theme.particles} />;
};
